import { PayloadAction } from '@reduxjs/toolkit';
import { setRawFieldValues } from '@ui/features/quote-builder/state/utilities/raw-field-values';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function csrSet(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{
    csrOid: string | null;
    csrName: string | null;
    csrEmail: string | null;
  }>,
) {
  const { csrOid, csrName, csrEmail } = action.payload;

  state.csrOid = csrOid;
  state.csrName = csrName;
  state.csrEmail = csrEmail;

  setRawFieldValues(state, [
    { uuid: state.uuid, field: 'csrOid', value: csrOid ?? '' },
    { uuid: state.uuid, field: 'csrName', value: csrName ?? '' },
    { uuid: state.uuid, field: 'csrEmail', value: csrEmail ?? '' },
  ]);
}
